import React from 'react';

const Header = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <img
                        src="https://img.freepik.com/free-vector/happy-birthday-flags-confetti-card_1017-32699.jpg?w=996&t=st=1698357693~exp=1698358293~hmac=cbdbe3b35415680e66097becb6b9db475bdf4dba5a1411cdfc8ba2d096bbda0d"
                        alt="Happy Birthday"
                        className="img-fluid"
                    />
                </div>
            </div>
        </div>
    );
}

export default Header;
